import { render, staticRenderFns } from "./PollingDetailMsg.vue?vue&type=template&id=73f5cd94&scoped=true&"
import script from "./PollingDetailMsg.vue?vue&type=script&lang=js&"
export * from "./PollingDetailMsg.vue?vue&type=script&lang=js&"
import style0 from "./PollingDetailMsg.vue?vue&type=style&index=0&id=73f5cd94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f5cd94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
